module.exports = __webpack_public_path__ + "static/media/on-regional.1fdc366f.png";